"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rejectPromotionInvite = void 0;
const tslib_1 = require("tslib");
function rejectPromotionInvite(options) {
  return tslib_1.__awaiter(this, void 0, void 0, function* () {
    const {
      invitorAddress
    } = options || {};
    // reject the promotion invite
    this.disconnect({
      peerAddress: invitorAddress
    });
  });
}
exports.rejectPromotionInvite = rejectPromotionInvite;
//# sourceMappingURL=rejectPromotionInvite.js.map